export enum NotificationType {
    CompanyUnderReview = 'CompanyUnderReview',
    OpportunityUnderReview = 'OpportunityUnderReview',
    PlanUpgradeRequestUnderReview = 'PlanUpgradeRequestUnderReview',
    PromptPayRequestUnderReview = 'PromptPayRequestUnderReview',
    PromptPayRequestApproved = 'PromptPayRequestApproved',
    PromptPayRequestRejected = 'PromptPayRequestRejected',
}